import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-datepicker', 'chooseDate', 'Pasirinkite datą');
Labels.set('ui-datepicker', 'selectedDate', 'Pasirinkta datą');
Labels.set('ui-datepicker', 'close', 'Uždaryti');
Labels.set('ui-datepicker', 'clear', 'Išvalyti įvestį');
